import React from 'react';
import { useNavigate } from 'react-router-dom';

const STATUS_OPTIONS = [
    { value: 'incoming', label: 'Incoming', path: '/incoming-applications' },
    { value: 'accepted', label: 'Accepted', path: '/status/accepted' },
    { value: 'rejected', label: 'Rejected', path: '/status/rejected' }
];

/**
 * Status switcher for onboarding screens.
 * Lets admins jump between Incoming / Accepted / Rejected without sidebar tabs.
 */
const OnboardingStatusFilter = ({ current }) => {
    const navigate = useNavigate();

    const handleChange = (event) => {
        const next = STATUS_OPTIONS.find((option) => option.value === event.target.value);
        if (next && next.value !== current) {
            navigate(next.path);
        }
    };

    return (
        <select
            value={current}
            onChange={handleChange}
            aria-label="Filter by onboarding status"
            className="px-3 py-2 border border-gray-300 rounded-md bg-white font-medium text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
            {STATUS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default OnboardingStatusFilter;
